"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ICON_SIZES", {
  enumerable: true,
  get: function get() {
    return _helpers.ICON_SIZES;
  }
});
exports.default = exports.Icon = void 0;
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactUiTheming = require("@concur/react-ui-theming");
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _isString = require("../utils/isString");
var _manifest_icons = _interopRequireDefault(require("./manifest_icons"));
var _manifest_svg_icons = _interopRequireDefault(require("./manifest_svg_icons"));
var _manifest_padded_lg_icons = _interopRequireDefault(require("./manifest_padded_lg_icons"));
var _manifest_padded_sm_icons = _interopRequireDefault(require("./manifest_padded_sm_icons"));
var _SvgIcon = require("./_SvgIcon");
var _helpers = require("./_helpers");
var _Icon = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Icon.css") : void 0);
var _excluded = ["ariaHidden", "ariaLabel", "className", "forceSize", "iconName", "path1ClassName", "path2ClassName", "role", "size"];
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; } // generated; see scripts/buildIconManifest.js
// generated; see scripts/buildIconManifest.js
// generated; see scripts/buildIconManifest.js
// generated; see scripts/buildIconManifest.js
var CSS_BLOCK = 'sapcnqr-icon';

/**
 * **Icon** components are either used to decorate a site or application or
 * convey meaning for certain elements within a site or application.
 */
var Icon = exports.Icon = /*#__PURE__*/_react.default.forwardRef(function (_props, ref) {
  var _context, _context2;
  var addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  var props = addChildProps ? _objectSpread(_objectSpread({}, _props), addChildProps(Icon, _props)) : _props;
  var ariaHidden = props.ariaHidden,
    ariaLabel = props.ariaLabel,
    className = props.className,
    forceSize = props.forceSize,
    iconName = props.iconName,
    path1ClassName = props.path1ClassName,
    path2ClassName = props.path2ClassName,
    _props$role = props.role,
    role = _props$role === void 0 ? 'img' : _props$role,
    _props$size = props.size,
    size = _props$size === void 0 ? 'sm' : _props$size,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var themeProviderContext = (0, _react.useContext)(_reactUiTheming.ThemeProviderContext);
  var _ref = themeProviderContext || {},
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'concur_default' : _ref$theme;
  var classnames = _bind.default.bind(_Icon.default);
  var baseClasses = classnames(CSS_BLOCK, (0, _concat.default)(_context = "".concat(CSS_BLOCK, "--")).call(_context, iconName), (0, _concat.default)(_context2 = "".concat(CSS_BLOCK, "--")).call(_context2, size), className);
  if (_manifest_svg_icons.default.some(function (iconNm) {
    return iconNm === iconName;
  })) {
    return /*#__PURE__*/_react.default.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({}, otherProps, {
      ariaHidden: ariaHidden,
      "aria-label": ariaLabel,
      className: baseClasses,
      iconName: iconName,
      path1ClassName: path1ClassName,
      path2ClassName: path2ClassName,
      ref: ref,
      size: size,
      title: ariaLabel || null
    }));
  }
  var hasLargePadding = false;
  var hasSmallPadding = false;
  if ((0, _helpers.isPaddedIconTheme)(theme)) {
    hasLargePadding = _manifest_padded_lg_icons.default.some(function (iconNm) {
      return iconNm === iconName;
    });
    // can't be both large and small so short circuit if a match was found
    // in PADDED_LARGE_ICON_NAMES
    hasSmallPadding = !hasLargePadding && _manifest_padded_sm_icons.default.some(function (iconNm) {
      return iconNm === iconName;
    });
  }
  var classes = classnames(baseClasses, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "--pad-lg"), hasLargePadding), "".concat(CSS_BLOCK, "--pad-sm"), hasSmallPadding));
  return /*#__PURE__*/_react.default.createElement("i", (0, _extends2.default)({}, otherProps, {
    "aria-hidden": ariaHidden,
    "aria-label": ariaLabel,
    className: classes,
    ref: ref,
    role: ariaHidden ? undefined : role
  }));
});
Icon.displayName = 'Icon';
Icon.propTypes = {
  /** The name of the desired icon. See Available Icons example for a complete list.
   *
   * Note: If using any 'messaging-' icons, this component will render an `<svg>`
   * element, all other icons render an `<i>` element. */
  iconName: _propTypes.default.oneOf(_manifest_icons.default).isRequired,
  /** The value for the `aria-hidden` attribute. Set to `true` when there
   * is already visible text explaining the **Icon** or when the **Icon**
   * is purely for decoration. */
  ariaHidden: _propTypes.default.bool,
  /** Text to describe the **Icon**. The value is placed in the 'aria-label' attribute. */
  // eslint-disable-next-line consistent-return
  ariaLabel: function ariaLabel(props) {
    // if icon is not hidden, warn if it doesn't have
    // a valid ariaLabel or a valid aria-labelledby
    if (!props.ariaHidden && !((0, _isString.isString)(props.ariaLabel) || (0, _isString.isString)(props['aria-labelledby']))) {
      return new Error('ariaLabel or aria-labelledby is required if ariaHidden is false and must be a string');
    }
  },
  /** Custom classes to add to the **Icon** component's tag. */
  className: _propTypes.default.string,
  /** Use to forcefully set the size of the icon.  This was override any
   * contextual sizing rules such as buttons or links. */
  forceSize: _propTypes.default.oneOf(_helpers.ICON_SIZES),
  /** Custom classes to add to an SVG's first path tag. */
  path1ClassName: _propTypes.default.string,
  /** Custom classes to add to an SVG's second path tag. */
  path2ClassName: _propTypes.default.string,
  /** Semantic role of Icon i.e. the `<i>` element. */
  role: _propTypes.default.oneOf(['button', 'img', 'presentation']),
  /** **Icon** size. Options are 'lg', 'lg-minus', 'md-plus', 'md', 'md-minus',
   * 'sm-plus', 'sm', 'sm-minus', 'xs-plus', 'xs'. */
  size: _propTypes.default.oneOf(_helpers.ICON_SIZES)
};
var _default = exports.default = Icon;